import Link, { LinkProps } from "./Link";

export { Link, LinkProps };

export default Link;
